import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import StartPage from '@/components/StartPage'
import NotFoundPage from '@/components/NotFoundPage'
import Register from '@/components/register/Register'
import Activation from '@/components/activation/Activation'
import Reset from '@/components/activation/Reset'
import Home from '@/components/home/Home'
import Invoices from '@/components/home/invoices/Invoices'
import SingleInvoice from '@/components/home/invoices/single-invoice/SingleInvoice'
import Dashboard from '@/components/home/dashboard/Dashboard'
// import RegisterInvoice from '@/components/home/register-invoice/RegisterInvoice'
import SettleInvoice from '@/components/home/settlement/SettleInvoice'
import UserSettlements from '@/components/home/user-settlements/UserSettlements'
import UserAdministration from '@/components/home/user-administration/UserAdministration'
import UserRegistration from '@/components/home/user-registration/UserRegistration'
import UserApproval from '@/components/home/user-registration/user-approval/UserApproval'
import UserInformation from '@/components/home/user-administration/user-management/user-information/UserInformation'
import LocalUserInformation from '@/components/home/user-administration/local-user-management/local-user-information/LocalUserInformation'
import UserProfile from '@/components/home/user-administration/user-profile/UserProfile'
import ReportedIssues from '@/components/home/issues/ReportedIssues'
import SingleIssue from '@/components/home/issues/single-issue/SingleIssue'
import GroupSettlement from '@/components/home/group-settlement/GroupSettlement'
import SingleGroupSettlement from '@/components/home/group-settlement/single-group-settlement/SingleGroupSettlement'
import RegisterGroupSettlement from '@/components/home/group-settlement/register-group-settlement/RegisterGroupSettlement'
import ListGroupSettlement from '@/components/home/group-settlement/list-group-settlement/ListGroupSettlement'
import Interventions from '@/components/home/intervention/Interventions'
import i18n from '@/i18n'

let $t = i18n.messages[i18n.locale]

import { accessTokenValid, refreshTokenValid, refreshToken } from './auth'

Vue.use(VueRouter)
Vue.use(VueResource)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      name: 'start-page',
      path: '/',
      component: StartPage
    },
    {
      name: 'notfound-page',
      path: '/not-found',
      component: NotFoundPage
    },
    {
      name: 'register',
      path: '/register',
      component: Register,
      meta: {
        title: $t.register.title
      }
    },
    {
      name: 'activation',
      path: '/activation',
      component: Activation
    },
    {
      name: 'reset',
      path: '/reset-password',
      component: Reset
    },
    {
      path: '/',
      component: Home,
      meta: {requiresAuth: true},
      children: [
        {
          path: 'dashboard',
          component: Dashboard,
          meta: {
            title: 'Dashboard'
          }
        },
        {
          path: 'reported-issues',
          component: ReportedIssues,
          meta: {
            title: $t.sidebar.reportedIssues
          }
        },
        {
          path: 'invoices',
          component: Invoices,
          meta: {
            title: $t.invoices.invoiceReview
          }
        },
        // {
        //   path: 'register-invoice',
        //   component: RegisterInvoice,
        //   meta: {
        //     title: $t.sidebar.registerInvoice
        //   }
        // },
        {
          path: 'user-administration',
          component: UserAdministration,
          meta: {
            title: $t.sidebar.userAdministration
          }
        },
        {
          path: 'user-registration',
          component: UserRegistration,
          meta: {
            title: $t.sidebar.userRegistration
          }
        },
        {
          path: 'settle-invoice',
          component: SettleInvoice,
          meta: {
            title: $t.sidebar.userRegistration
          }
        },
        {
          path: 'user-settlements',
          component: UserSettlements,
          meta: {
            title: $t.sidebar.invoiceUserSettlement
          }
        },
        {
          path: 'invoices/:invoiceId',
          name: 'singleInvoiceRoute',
          component: SingleInvoice,
          meta: {
            title: $t.sidebar.registerInvoice
          }
        },
        {
          path: 'user-registration/approval/:registrationId',
          component: UserApproval,
          name: 'approvedUserPage'
        },
        {
          path: 'user-administration/local-user/:userId',
          name: 'userInfoPage',
          component: LocalUserInformation
        },
        {
          path: 'user-administration/user/:userId',
          component: UserInformation,
          name: 'userInformationPage'
        },
        {
          path: 'user-administration/profile',
          component: UserProfile
        },
        {
          path: 'reported-issues/:issueId',
          component: SingleIssue,
          meta: {
            title: $t.sidebar.reportedIssues
          }
        },
        {
          path: 'group-settlement',
          meta: {
            title: $t.sidebar.groupSettlement
          },
          component: GroupSettlement,
          children: [
            {
              path: 'register',
              name: 'registerGroupSettlementRoute',
              component: RegisterGroupSettlement
            },
            {
              path: ':groupSettlementId',
              name: 'singleGroupSettlementRoute',
              component: SingleGroupSettlement
            },
            {
              path: '',
              name: 'listGroupSettlementRoute',
              component: ListGroupSettlement
            }
          ]
        },
        {
          path: 'intervention',
          component: Interventions,
          meta: {
            title: $t.sidebar.intervention
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  i18n.locale = router.app.$store.getters.language === 'English' ? 'en' : 'sr'

  // Site title
  let siteName = $t.title
  let pageName

  if (to.name === 'start-page') {
    pageName = siteName
  } else {
    pageName = to.meta.title ? to.meta.title + ' - ' + siteName : siteName
  }

  document.title = pageName

  if (!to.matched.length) {
    next('/not-found')
  }

  let isProductionEnvironment = process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
  // Authorization
  if (!isProductionEnvironment) { console.log('Executing authorization guard for ' + to.path) }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!accessTokenValid()) {
      if (!refreshTokenValid()) {
        if (!isProductionEnvironment) { console.log('Tokens expired - routing not authorized') }
        next({
          path: '/',
          query: {redirect: to.fullPath}
        })
      } else {
        if (!isProductionEnvironment) { console.log('Refreshing access token') }
        refreshToken(to, from, next)
      }
    } else {
      if (!isProductionEnvironment) {
        console.log('Routing authorized for: ' + to.path + ' | Route Name: ' + to.name)
      }
      next()
    }
  } else {
    if (!isProductionEnvironment) { console.log('No authorization required for ' + to.path) }
    next() // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js